/* eslint-disable */
(function(algolia) {
    'use strict';

    
      var isAlgoliaToggle = true;
    

    var instantsearch = algolia.externals.instantsearch;
    var algoliasearch = algolia.externals.algoliasearch;
    var searchBox = algolia.externals.widgets.searchBox;
    var stats = algolia.externals.widgets.stats;
    var sortBy = algolia.externals.widgets.sortBy;
    var clearRefinements = algolia.externals.widgets.clearRefinements;
    var panel = algolia.externals.widgets.panel;
    var hits = algolia.externals.widgets.hits;
    var pagination = algolia.externals.widgets.pagination;
    var configure = algolia.externals.widgets.configure;
    var html = algolia.externals.html;
    var connectCurrentRefinements =
      algolia.externals.connectors.connectCurrentRefinements;
    const productJson = document.querySelector('.js-product-json');
    const json = productJson?.innerHTML ? JSON.parse(productJson?.innerHTML) : {};
    const { selectedOrFirstAvailableVariant, variantMetafields = {} } = json;
    const productVariantMetafields = Object.keys(variantMetafields).length ? variantMetafields[`${selectedOrFirstAvailableVariant}.${'display'}`] : undefined;
    const widgetCollection = productVariantMetafields?.widget_collection ? productVariantMetafields?.widget_collection : undefined;
    const connectSortBy = algolia.externals.connectors.connectSortBy;
    const connectRefinementList = algolia.externals.connectors.connectRefinementList;
    const connectRange = algolia.externals.connectors.connectRange;
    const { useState, useEffect, useRef, useCallback, render } = algolia.externals;

    // Nothing upstream of instant.search.start() has any error handling, and start() is what
    // actually wires up every already-registered widget's click handlers/init. One unguarded
    // throw here (e.g. a missing facet container) silently prevents start() from ever running,
    // leaving the whole filter bar/drawer painted but completely non-interactive.
    function safelyMountWidget(label, mountFn) {
      try {
        mountFn();
      } catch (error) {
        console.error('Algolia widget failed to mount (' + label + ') - continuing with the rest:', error);
      }
    }

    var collectionPageEnabled =
      algolia.is_collection_results_page &&
      algolia.config.instant_search_enabled_on_collection;

    const client = algoliasearch(algolia?.config?.app_id, algolia?.config?.search_api_key);
    const index = client.initIndex(algolia?.config?.index_prefix+'products');

    algolia.renderCarousel(widgetCollection, json ,index);

    if (!algolia.full_results && !algolia.is_collection_results_page) {
      /**
       * If we aren't on the search page and neither on a collection page,
       * then there's no need to proceed
       */
      return;
    } else if (algolia.full_results) {
      /**
       * If we are on the search page and instant search isn't enabled,
       * then there's no need to proceed
       */
      if (!algolia.config.instant_search_enabled) {
        return;
      }
    } else if (algolia.is_collection_results_page) {
      /**
       * If we are on a collection page and instant search on collection isn't
       * enabled, then there's no need to proceed
       */
      if (!algolia.config.instant_search_enabled_on_collection) {
        return;
      }
    }
  
    /**
     * Array which will contain all filters to be applied while initiating the
     * search API call.
     */
    var searchFilters = [];
  
    var collectionFacetFilter = null;
    var collectionRulesContextValue = null;
    var collectionHandle = null;
  
    if (collectionPageEnabled) {
      var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
      collectionHandle =
        Boolean(matches) && matches.length === 2 ? matches[1] : null;
  
      if (algolia.config.collection_id_indexing) {
        collectionFacetFilter = collectionHandle
          ? 'collections:"' + collectionHandle + '"'
          : null;
      } else {
        collectionFacetFilter = 'collections:"' + collectionHandle + '"';
      }
  
      // Add the collection filter to the list of search filters
      searchFilters.push(collectionFacetFilter);
  
      collectionRulesContextValue = algolia.config.collection_id_query_rules
        ? algolia.current_collection_id
        : collectionHandle;
    }
  
    // Filters for stock policy
    var stockPolicyFilter = null;
    if (algolia.config.stock_policy) {
      if (algolia.config.stock_policy === 'allow') {
        /**
         * For 'allow', we don't need to add any filter as we want to continue
         * displaying all out of stock items.
         */
      } else if (algolia.config.stock_policy === 'deny') {
        // For 'deny' we will filter out all items based on inventory quantity
        stockPolicyFilter = 'inventory_quantity > 0';
      } else if (algolia.config.stock_policy === 'continue') {
        /**
         * For 'continue' we will filter on `inventory_available` attribute whose
         * value is dependent on:
         * `inventory_quantity > 0 OR inventory_policy == 'continue'`
         */
        stockPolicyFilter = 'inventory_available:true';
      }
  
      // Add the stock policy filter to the list of search filters
      if (stockPolicyFilter) {
        searchFilters.push(stockPolicyFilter);
      }
    }
  
    var results_selector = collectionPageEnabled
      ? algolia.config.collection_css_selector
      : algolia.config.results_selector;
  
    var activeSortOrders =
      collectionPageEnabled && algolia.collectionSortOrders
        ? algolia.collectionSortOrders
        : algolia.sortOrders;
  
    results_selector += ', .algolia-shopify-instantsearch';
  
    function getTrackedUiState(uiState) {
      var trackedUiState = {};
      Object.keys(uiState).forEach(function(k) {
        if (k === 'configure' || k === 'query' || k === 'q') {
          return;
        }
        trackedUiState[k] = uiState[k];
      });
      return trackedUiState;
    }
  
    /**
     * List of URL params which are "allowed" by InstantSearch.
     * These parameters won't be overwritten when the search state is written
     * to the URL.
     */
    var ALLOWED_FOREIGN_PARAMS = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ];
    var foreignRouteState;
  
    function singleIndex(indexName) {
      return {
        /**
         * `stateToRoute` method transforms the `uiState` object from InstantSearch
         * into an object that will then be serialized to construct the URL.
         */
        stateToRoute: function(uiState) {
          var route = getTrackedUiState(uiState[indexName] || {});
          route.q = uiState[indexName].query;
          return Object.assign({}, foreignRouteState, route);
        },
  
        /**
         * `routeToState` method transforms the route object into a `uiState` object
         * so that InstantSearch is initialized with the correct state from the
         * URL.
         */
        routeToState: function(routeState) {
          /**
           * Backup parameters from `routeState` into a different object
           * `foreignRouteState` so that we can re-inject them into the object
           * returned within `stateToRoute`.
           * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
           * array.
           */

          const urlParams = new URLSearchParams(window.location.search);
          const queryParamKeys = Array.from(urlParams.keys());
          ALLOWED_FOREIGN_PARAMS = ALLOWED_FOREIGN_PARAMS.concat(queryParamKeys);

          if (!foreignRouteState) {
            foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
              acc[key] = routeState[key];
              return acc;
            }, {});
          }
  
          var state = {};
          state[indexName] = getTrackedUiState(routeState || {});
          state[indexName].query = routeState.q;
          return state;
        },
      };
    }
  
    var instant = {
      colors: algolia.config.colors,
      distinct: Boolean(algolia.config.show_products),
      facets: {
        hidden:
          collectionPageEnabled && algolia.collectionHiddenFacets
            ? algolia.collectionHiddenFacets
            : algolia.hiddenFacets,
        shown:
          collectionPageEnabled && algolia.collectionShownFacets
            ? algolia.collectionShownFacets
            : algolia.shownFacets,
        list:
          collectionPageEnabled && algolia.collectionFacets
            ? algolia.collectionFacets
            : algolia.facets,
        widgets:
          collectionPageEnabled && algolia.collectionFacetsWidgets
            ? algolia.collectionFacetsWidgets//configurated widgets
            : algolia.facetsWidgets,//default collection widgets
      },
      hitsPerPage:
        collectionPageEnabled &&
        algolia.config.collections_full_results_hits_per_page
          ? algolia.config.collections_full_results_hits_per_page
          : algolia.config.products_full_results_hits_per_page,
      search: instantsearch({
        searchClient: algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
        ),
        indexName: algolia.config.index_prefix + 'products',
        insights: algolia.config.analytics_enabled,
        routing:  {
          stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
        },
        searchFunction: function(searchFunctionHelper) {
          // Set query parameters here because they're not kept when someone
          // presses the Back button if set in the `init` function of a custom widget
          var page = searchFunctionHelper.getPage();
          if (instant.distinct) {
            searchFunctionHelper.setQueryParameter('distinct', true);
          }
  
          // Assign any required filters
          if (searchFilters.length) {
            searchFunctionHelper.setQueryParameter(
              'filters',
              searchFilters.join(' AND ')
            );
          }
  
          // Assign any required `ruleContexts` which are required for query rules
          // targeting collection pages
          if (collectionPageEnabled) {
            var ruleContextString = collectionRulesContextValue ? "collection_page" : "search_results"
            
            // Collection page merchandising:
            // If we are on a collection page, `collectionRulesContextValue` is defined
            if (collectionRulesContextValue) {
              searchFunctionHelper.setQueryParameter('ruleContexts', [
                collectionRulesContextValue.toString(), ruleContextString
              ]);
              searchFunctionHelper.setQueryParameter('analyticsTags', [
                collectionRulesContextValue.toString(), ruleContextString
              ]);
            } else {
              //if collectionPageEnabled is true then logically collectionRulesContextValue will be defined...this else statement is never reached.
              searchFunctionHelper.setQueryParameter('ruleContexts', [ ruleContextString ]);
            }
          }
          searchFunctionHelper.setQueryParameter('facetingAfterDistinct',false);
  
          searchFunctionHelper.setPage(page);
          searchFunctionHelper.search();
        },
      }),
      selector: results_selector + ', .algolia-shopify-instantsearch',
      sortOrders: activeSortOrders
    };
    
    instant.search.client.addAlgoliaAgent('Shopify Integration');
  
    algolia.instantsearch = instant;
  
  
    function readjust() {
      var width = instant.$results.offsetWidth;
  
      var suffix = 'lg';
      if (width < 400) suffix = 'xs';
      else if (width < 800) suffix = 'sm';
      else if (width < 1200) suffix = 'md';
  
      instant.$results.classList.remove('ais-results-size-xs');
      instant.$results.classList.remove('ais-results-size-sm');
      instant.$results.classList.remove('ais-results-size-md');
      instant.$results.classList.remove('ais-results-size-lg');
      instant.$results.classList.add('ais-results-size-' + suffix);
    }
  
  
    //Link CSS and set up CSS variables
    const cssFile = document.getElementById('template_algolia_instant_search.css');
    document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
    document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
    document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
    algolia.appendStyle(cssFile.text);
  
    if (collectionPageEnabled) {
      if (
        document.querySelectorAll(algolia.config.collection_css_selector)
          .length === 0
      ) {
        throw new Error(
          'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
        );
      }
    } else if (
      document.querySelectorAll(algolia.config.results_selector).length === 0
    ) {
      throw new Error(
        'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
      );
    }
  
    // Instantiating the main page
    instant.$results = document.querySelector(instant.selector);
    instant.$results.innerHTML = '';
  
    const params = new URLSearchParams(window.location.search);
    const isAlgolia = isAlgoliaToggle || params.get('algolia') === 'true';
    const collectionPage = document.querySelector('#collection_page');
    if(isAlgolia && collectionPage) collectionPage.classList.add('isAlgolia')
    let paginationWidgetCSS ={};
    if(isAlgolia){
      paginationWidgetCSS = {
        selectedItem:'selected_item',
        link:'pagination-link',
      }
    }

    // instant.facets.shown so it matches what we use in custom facets widget
    // and range slider widget files. List of widgets is based on collectionPageEnabled
    algolia.render(isAlgolia ? algolia.instantSearchMainPage : algolia.instantSearchMainTemplate, instant.$results, {
      facets: instant.facets.shown,
      multipleSortOrders: activeSortOrders.length > 1,
      collectionSortOrders: algolia.collectionSortOrders
    });

    algolia.closeFacetDropdowns = function(setState){
      document.addEventListener('algolia:facets:closeAllDropdowns', function(){
        setState(false);
      });
    }
    
    isAlgolia && safelyMountWidget('mobile sort', () => algolia.instantSearchMobileSortWidget(instant, sortBy, isAlgolia, activeSortOrders, connectSortBy, html, useState, useEffect, render));
    isAlgolia && safelyMountWidget('desktop sort', () => algolia.instantSearchDesktopSortWidget(instant, sortBy, isAlgolia, activeSortOrders, connectSortBy, html, useState, useEffect, render));
    isAlgolia && safelyMountWidget('custom facets', () => algolia.instantSearchCustomFacetsWidget(instant, isAlgolia, connectRefinementList, html, useState, render));
    isAlgolia && safelyMountWidget('price slider', () => algolia.instantSearchCustomSliderWidget(instant, isAlgolia, connectRange, html, useState, useEffect, useRef, useCallback, render));
    isAlgolia && safelyMountWidget('selected filter indicators (mobile)', () => algolia.instantSearchSelectedFilterIndicators(instant, isAlgolia, connectCurrentRefinements, html, useState, useEffect, render));
    isAlgolia && safelyMountWidget('selected filter indicators (desktop)', () => algolia.instantSearchDesktopSelectedFilterIndicators(instant, isAlgolia, connectCurrentRefinements, html, useState, useEffect, render));
    // Sort orders
    // instantSearchMainPage function in algolia_instant_search_main_page.liquid contains the container class names below
    // Order matters, this code needs to be after the instantSearchMainPage function.
    if (activeSortOrders.length > 1) {
      instant.search.addWidgets([
        sortBy({
          container: '.ais-sort-orders-container',
          items: instant.sortOrders,
        }),
      ]);
      if (!isAlgolia) {
        instant.search.addWidgets([
          sortBy({
            container: '.mobile-sort-button',
            items: instant.sortOrders,
          }),
        ]);
      }
    };

    readjust();
  
    window.addEventListener('resize', function() {
      readjust();
    });
      
    // Mobile facets display
    instant.search.addWidgets([
      {
        init: function() {
          // For algolia 2 just toggle hidden css instead and use new classes
          const facets = isAlgolia ? '.facets-overlay' : '.ais-facets';
          const showFacets = isAlgolia ? 'hidden' : 'ais-facets__shown';

          var $facets = document.querySelector(facets);
          // Buttons that have the class toggle-facets, ie filter button
          var $buttons = document.querySelectorAll('.toggle-facets');

          $buttons.forEach((button)=>{
            button.addEventListener('click', function() {
              $facets.classList.toggle(showFacets);
            });
          })
        },
      },
    ]);
  
    instant.search.addWidgets([
      configure({
        hitsPerPage: instant.hitsPerPage,
        facetingAfterDistinct: Boolean(algolia.config.show_products),
        ruleContexts: ["search_results"],
        analyticsTags:["search_results"]
      }),
    ]);
  
    // Search input
    instant.search.addWidgets([
      searchBox({
        container: '.ais-search-box-container',
        placeholder: algolia.translations.searchForProduct,
        showReset: false,
        showSubmit: false,
      }),
    ]);

    // Logo & clear
    instant.search.addWidgets([
      {
        init: function(opts) {
          document
            .querySelector('.ais-clear-input-icon')
            .addEventListener('click', function() {
              opts.helper.setQuery('').search();
              var input = document.querySelector('.ais-search-box--input');
              input.value = '';
              input.focus();
            });
        },
        render: function(opts) {
          if (!opts.state.query) {
            document.querySelector('.ais-clear-input-icon').style.display =
              'none';
          } else {
            document.querySelector('.ais-clear-input-icon').style.display = '';
          }
        },
      },
    ]);
  
    algolia.instantSearchStatsWidgets(instant, stats, isAlgolia);

    if(!isAlgolia) {
      // Change Display
      instant.search.addWidgets([
        {
          init: function() {
            document
              .querySelector('.ais-search-header .ais-change-display-block')
              .addEventListener('click', function() {
                document
                  .querySelector(
                    '.ais-change-display-block:not(.ais-change-display-selected)'
                  )
                  .classList.add('ais-change-display-selected');
                document
                  .querySelector(
                    '.ais-change-display-list.ais-change-display-selected'
                  )
                  .classList.remove('ais-change-display-selected');
                document
                  .querySelector('.ais-results-as-list')
                  .classList.replace('ais-results-as-list', 'ais-results-as-block');
              });
            document
              .querySelector('.ais-search-header .ais-change-display-list')
              .addEventListener('click', function() {
                document
                  .querySelector(
                    '.ais-change-display-list:not(.ais-change-display-selected)'
                  )
                  .classList.add('ais-change-display-selected');
                document
                  .querySelector(
                    '.ais-change-display-block.ais-change-display-selected'
                  )
                  .classList.remove('ais-change-display-selected');
                document
                  .querySelector('.ais-results-as-block')
                  .classList.replace('ais-results-as-block', 'ais-results-as-list');
              });
          },
        },
      ]);
    }

    // Hidden facets
    var list = instant.facets.hidden.map(function(facet) {
      return facet.name;
    });
    instant.search.addWidgets([
      {
        getConfiguration: function() {
          return {
            facets: list,
            disjunctiveFacets: list,
          };
        },
        init: function() {},
      },
    ]);
  
    // Create the render function
    var createDataAttributes = function(refinement) {
      return Object.keys(refinement)
        .map(function(key) {
          return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
        })
        .join(' ');
    };
  
    var renderListItem = function(item) {
      var facet = instant.facets.list.find(function(f) {
        return f.name === item.label;
      });
      return item.refinements
        .map(function(refinement) {
          return (
            '<li class="ais-current-refined-values--item">' +
            '  <a ' +
            createDataAttributes(refinement) +
            '    class="ais-current-refined-values--link">' +
            '    <div>' +
            '      <div class="ais-current-refined-values--label">' +
            facet.title +
            '      </div>: ' +
            refinement.label +
            '    </div>' +
            '  </a>' +
            '</li>'
          );
        })
        .join('');
    };
  
    // Mirrored what algolia provided by default. 
    // This creates the bubbles ui.
    const bubblesListItem = function(item) {
      return item.refinements
        .map(function(refinement) {
          return (
            '<section class="current-refined-values--item facet-bubbles_items bg-gray-brown h-8 px-3 py-2 mr-3 mt-2 flex items-center">' +
            '  <a ' +
            createDataAttributes(refinement) +
            '    class="current-refined-values--link">' +
            '    <div>' +
            '      <div class="current-refined-values--label">' +
            '      </div>' +
            '    <section class="facet-bubbles_items flex items-center">' +
            '      <section class="mr-3">' +
            refinement.label.trim() +
            '      </section>' +
            '      <section>' +
            `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <path d="M1 7.0002L7 1.00098" stroke="#1A1713" stroke-linejoin="round"/>
                <path d="M7 6.99902L1 0.999797" stroke="#1A1713" stroke-linejoin="round"/>
                </svg>` +
            '      </section>' +
            '    </section>' +
            '    </div>' +
            '  </a>' +
            '</section>'
          );
        })
        .join('');
    };

    // If algolia 2.0 then we provide our own parent container for the bubbles
    /**
     * Create your own UI of the currentRefinements widget, you can use connectors
     * https://www.algolia.com/doc/api-reference/widgets/current-refinements/js/#create-a-render-function
     * @param renderOptions 
     */
    var renderCurrentRefinements = function(renderOptions) {
      var items = renderOptions.items;
      var refine = renderOptions.refine;
      var widgetParams = renderOptions.widgetParams;

      widgetParams.container.innerHTML =
          '<div class="ais-current-refined-values--header ais-facet--header ais-header">Selected filters</div>' +
          '<div class="ais-root ais-current-refined-values ais-facet">' +
          '  <ul class="ais-current-refined-values--list">' +
          items.map(renderListItem).join('') +
          '  </ul>' +
          '</div>';
  
      const clearAndSearchFilter = (event) => {
        // since dataset is returned as DOMStringMap, and label and value
        // contain html encoded characters, we need to decode them
        // so item variable becomes an object with string values.
        var item = Object.keys(event.currentTarget.dataset).reduce(function(
          acc,
          key
        ) {
          var itemData = {};
          itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
          return algolia.assign({}, acc, itemData);
        },
        {});
        
        // Clears a single refinement and triggers a new search
        // https://www.algolia.com/doc/api-reference/widgets/current-refinements/js/#connector-param-render-rendering-options-2
        refine(item);
      }

      /**
       * Bubbles
       * If algolia 2.0 we want to give our own class so once we click on the bubble we can remove it
       */
      const bubbles = widgetParams.container.querySelectorAll(
        '.ais-current-refined-values--link'
      );

      Array.prototype.slice.call(bubbles).forEach(function (bubble) {
        // seems like everytime a refinement is clicked, the event is triggered
        bubble.addEventListener('click', clearAndSearchFilter);
      });
    };
  
    // Create the custom widget
    var customCurrentRefinements = connectCurrentRefinements(
      renderCurrentRefinements
    );
  
    var hasRefinements = function(helper, facetsList) {
      return facetsList.some(function(f) {
        var isConjunctiveFacetRefined =
          helper.state.isConjunctiveFacet(f.name) &&
          helper.state.isFacetRefined(f.name);
        var isDisjunctiveFacetRefined =
          helper.state.isDisjunctiveFacet(f.name) &&
          helper.state.isDisjunctiveFacetRefined(f.name);
        var isHierarchicalFacetRefined =
          helper.state.isHierarchicalFacet(f.name) &&
          helper.state.isHierarchicalFacetRefined(f.name);
  
        var numericRefinements = helper.state.getNumericRefinements(f.name);
        var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
          operator
        ) {
          return numericRefinements[operator].length > 0;
        });
  
        return (
          isNumericFacetRefined ||
          isConjunctiveFacetRefined ||
          isDisjunctiveFacetRefined ||
          isHierarchicalFacetRefined
        );
      });
    };
  
    /**
     * Decides whether the given `facetName` has any facet values available in
     * the current result set by checking the available `facets`,
     * `disjunctiveFacets` and `hierarchicalFacets`.
     */
    var hasFacetValues = function(resultState, facetName) {
      var isFacetValueAvailable = resultState.facets.some(function(facet) {
        return facet.name === facetName;
      });
      var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
        function(facet) {
          return facet.name === facetName;
        }
      );
      var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
        function(facet) {
          return facet.name === facetName;
        }
      );
  
      return (
        isFacetValueAvailable ||
        isDisjunctiveFacetValueAvailable ||
        isHierarchicalFacetValueAvailable
      );
    };
  
    var customCurrentRefinementsWithPanel = panel({
      hidden: function(options) {
        return !hasRefinements(options.helper, instant.facets.list);
      },
    })(customCurrentRefinements);
  
    // hides clear filters button if no refinements
    // A2 wants to disable it and not hide it
    const clearRefinementsWithPanelParams = isAlgolia ? {} : {
      hidden: function(options) {
        return !hasRefinements(options.helper, instant.facets.list);
      }
    };

    var clearRefinementsWithPanel = panel(clearRefinementsWithPanelParams)(clearRefinements);
  
    const clearBtn = '.ais-clear-refinements-container';
    const clearBtnText = isAlgolia ? algolia.translations.ctaClearFilters : algolia.translations.clearAll;

    /**
     * Add the refinements widget to the search page.
     * If Algolia 2.0, we will add our own custom widget
     **/
    !isAlgolia && instant.search.addWidgets([
      clearRefinementsWithPanel({
        container: document.querySelector(clearBtn),
        templates: {
          resetLabel: clearBtnText?.toUpperCase(),
        },
      }),
      customCurrentRefinementsWithPanel({
        container: document.querySelector('.ais-current-refined-values-container'),
      }),
    ]);
  
    /**
     * Setup the facets for Algolia 1.0. If Algolia 2.0 don't run this code.
     * We are using a `panel` with a custom `hidden` function which will allow
     * us to hide the parent container of the facet if there are no facet values
     * available for that particular facet.
     */
    !isAlgolia && instant.facets.widgets.forEach(function(widget) {
      // Pass widget to panel's returned function. Ex:
      // const refinementListWithPanel = panel({
      //   templates: {
      //     header: 'Brand',
      //   },
      // })(refinementList);
      var facetWithPanel = panel({
        hidden: function(options) {
          var hide = !hasFacetValues(options.results, widget.params.attribute);
          var displayStyle = hide ? 'none' : '';
  
          /**
           * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
           * can work as expected. "." is supposed to be present for named tags
           * and metafield based facet names and "%" is present when the facet name has a space
           * in it because of the encoding.
           */
          var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
            widget.params.attribute
          ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
          var parentContainer = document.querySelector(parentContainerClassName);
  
          if (parentContainer) {
            parentContainer.style.display = displayStyle;
          }
  
          return hide;
        },
      })(widget.widget); // })(refinementList); example
      
      // instant.search.addWidgets([panel(widget.params)](refinementList));
      // widget.params contains config for panel and widget.
      instant.search.addWidgets([facetWithPanel(widget.params)]);
    });

    const { MAX_INDIVIDUAL_FILTERS } = algolia;

    // Individual facets
    isAlgolia && algolia?.searchResultFilters?.slice(0,MAX_INDIVIDUAL_FILTERS)?.forEach(function(widget) {
      try {
        var facetWithPanel = panel({
          hidden: function(options) {
            var hide = !hasFacetValues(options.results, widget.params.attribute);
            var displayStyle = hide ? 'none' : '';

            /**
             * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
             * can work as expected. "." is supposed to be present for named tags
             * and metafield based facet names and "%" is present when the facet name has a space
             * in it because of the encoding.
             */
            var parentContainerClassName = '.facet-' + encodeURIComponent(
              widget.params.attribute
            ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
            var parentContainer = document.querySelector(parentContainerClassName);

            if (parentContainer) {
              parentContainer.style.display = displayStyle;
            }

            return hide;
          },
        })(widget.widget);

        instant.search.addWidgets([facetWithPanel(widget.params)]);
      } catch (error) {
        // One individual-filter facet with no rendered container (e.g. it fell outside the
        // first MAX_INDIVIDUAL_FILTERS shown buttons) shouldn't abort mounting the rest.
        console.error('Algolia individual-filter widget failed to mount (' + widget?.params?.attribute + ') - continuing with the rest:', error);
      }
    });
  
    let classes = {};

    if(isAlgolia) {
      classes = {
        root: 'hits-container',
        list: 'results-as-list',
        item: 'hit-product-card',
        emptyRoot: 'hit-empty--no-results',
      }
    }

    // Hits
    instant.search.addWidgets([
      hits({
        container: '.ais-hits-container',
        templates: {
          item(hit, {html, components}) {
            return algolia.productCard(html, hit, undefined, collectionPageEnabled);
          },
          empty(results, {html}) {
            return algolia.instantSearchNoResultTemplate(html);
          }
        },
        cssClasses: classes,
        transformItems: function(items) {
          return items.map( item => ({
            ...item,
            _distinct: instant.distinct,
            can_order:
              item.inventory_management !== 'shopify' ||
              item.inventory_policy === 'continue' ||
              item.inventory_quantity > 0,
            queryID: item.__queryID,
            productPosition: item.__position,
            index: instant.search.mainIndex.getIndexName()
          }));
        }
      })
    ]);

    //requesting variants for distinct products in current search results, this is needed to display prices for distinct product cards
    instant.search.addWidgets([
      {
        render(renderOptions){
          algolia.updateDistinctPrices(renderOptions.results.hits,index,'instantsearch')
        }
      }
    ])
  
    // Redirect to product on click
    instant.search.addWidgets([
      {
        init: function() {
          var listOfProductCardsContainer = document.querySelector('.ais-hits-container');
          // Click event listener for the hits, list of all product cards including any space around the product card
          listOfProductCardsContainer.addEventListener('click', function(e) {
            // Get the element that was clicked
            var elementClicked = e.target;
            var hit;
            
            if (!elementClicked) {
              return;
            }

            // based on what you click, it will go up the DOM tree until it finds the product card container
            // Creates a hit element to grab its data attributes ie distinct, queryId, variantId, handle
            do {
              // if the element clicked is a product card, set hit to that element and exit loop
              if (elementClicked.matches('.ais-hit') || elementClicked.matches('.productCard')) {

                // product card cointainer is set to hit
                hit = elementClicked;
                // exit loop since we found the product card
                break;
              }
              // Set the element clicked to its parent so the next iteration will check the parent if it is the product card.
              elementClicked = elementClicked.parentNode;

              // while element clicked exists and is not the list of product cards container
              // elementClicked eventually will be the list of product cards container
              // since elementClicked gets overriten by elementClicked.parentNode
              // for example if you click outside the product card
            } while (elementClicked && elementClicked !== listOfProductCardsContainer);

            // If there is no hit stop executing the function
            if (!hit) {
              return;
            }

            // Grab the data attributes from the product card
            // that was set in file src/snippets/algolia_instant_search_product.liquid
            var $this = hit;
            var productHandle = $this.dataset.handle;
            var variant_id = $this.dataset.variantId;
            var distinct = $this.dataset.distinct;
            var queryId = $this.dataset.algoliaQueryid
  
            // Construct the link we should redirect to
            var link = '';
  
            // If we're on a collection page and the handle is available
            // then prefix the product link with the collection handle
            /* if (collectionPageEnabled && collectionHandle) {
              link = '/collections/' + collectionHandle;
            } */
  
            // Add the product handle to the link
            link = link + '/products/' + productHandle;
  
            // Add the variant ID details to redirect to a specific
            // variant ID if we are showing variants and not products
            if (distinct !== 'true') {
              link += '?variant=' + variant_id + '&qid=' + queryId
            }
            
            if(!elementClicked.matches('.productCard')){
              window.location.href = link;
            }
          });
        },
      },
    ]);
  
    // Add to cart
    instant.search.addWidgets([
      {
        init: function() {
          var container = document.querySelector('.ais-hits-container');
          container.addEventListener('click', function(e) {
            var el = e.target;
            var cartButton;

            if (!el) {
              return;
            }

            do {
              if (el.matches('.ais-hit--cart-button')) {
                cartButton = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!cartButton) {
              return;
            }
  
            e.stopPropagation();
            var $this = cartButton;
            var formId = $this.dataset.formId;
  
            if (formId) {
              document.getElementById(formId).submit();
            }
          });
        },
      },
    ]);
  
    // No result actions
    instant.search.addWidgets([
      {
        init: function(opts) {
          var container = document.querySelector('.ais-hits-container');
          container.addEventListener('click', function(e) {
            var el = e.target;
            var clearFilters;

            if (!el) {
              return;
            }

            do {
              if (el.matches('.ais-hit-empty--clear-filters')) {
                clearFilters = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!clearFilters) {
              return;
            }
  
            var helper = opts.helper;
            helper.clearTags();
            instant.facets.list.forEach(function(facet) {
              helper.clearRefinements(facet.name);
            });
            helper.search();
          });
  
          container.addEventListener('click', function(e) {
            var el = e.target;
            var clearInput;
            
            if (!el) {
              return;
            }

            do {
              if (el.matches('.ais-hit-empty--clear-input')) {
                clearInput = el;
                break;
              }
              el = el.parentNode;
            } while (el && el !== container);
            if (!clearInput) {
              return;
            }
  
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
        },
      },
    ]);

    
    // Pagination
    instant.search.addWidgets([
      pagination({
        container: '.ais-pagination-container',
        padding: 2,
        maxPages: 20,
        cssClasses:{...paginationWidgetCSS},
      }),
    ]);


    // Pagination click → dispatch update event. Delegated on document so it
    // attaches once, instead of re-binding on every Algolia render.
    document.addEventListener('click', (e) => {
      if (e.target.closest && e.target.closest('.ais-Pagination-list')) {
        // Blur the clicked link so the browser doesn't scroll the newly
        // focused pagination control into view (which lands mid-grid on mobile).
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
        document.dispatchEvent(new CustomEvent('la:dn:collection:updated'));
      }
    });

    instant.search.on("render", () => {
      // Defer until after the new grid has rendered. Use 'instant' explicitly
      // — 'auto' defers to CSS scroll-behavior, which is `smooth` globally
      // (main.css). On mobile, smooth scrolls get interrupted by layout
      // shifts from lazy-loaded images and leave the viewport mid-grid.
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
      });
    });

    instant.search.start();
  
    algolia.contentHide.parentNode.removeChild(algolia.contentHide);

    // Retrieve scroll position on page change
    window.addEventListener('popstate', () => {
      const scrollPos = sessionStorage.getItem('scrollPosition');
      if (scrollPos !== null) {
        window.scrollTo({ top: parseInt(scrollPos, 10), behavior: 'auto' });
        sessionStorage.removeItem('scrollPosition');
      }
    });

  })(window.algoliaShopify);
  //custom code
  const facet_list = document.querySelectorAll('.facet-label-container')
  facet_list.forEach((facet)=>{
    facet.addEventListener('click',function(){
      facet.classList.toggle("selected-facet")
    })
  })
  